export default __webpack_public_path__ + "static/media/Fishbowl.67849c10.png";